module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9vQRI9/images/cover.jpg?1684306039989",
      "alt": "This image is the cover for the book Hoops in Connecticut, Sports"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hoops in Connecticut, Sports\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Home to both the University of Connecticut�s men�s and women�s NCAA championship teams as well as the Connecticut Sun WNBA team, this small state has made a name for itself in basketball. Infatuation with the sport started here in 1896 with the first intercollegiate game between Yale and Wesleyan Universities. The roster of Connecticut�s round ball greats includes Naismith Hall-of-Famer Calvin Murphy; NBA stars Vin Baker, Marcus Camby, Charles Smith, the late John Williamson, Johnny Egan and John Bagley; and Harlem Globetrotter Alvin Clinkscales. Award-winning sportswriter Don Harrison wows fans with stories of the Nutmeg State�s most notable players and coaches through personal interviews and firsthand accounts.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Don Harrison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Don Harrison has covered basketball for the Waterbury Republican, Waterbury American and New Haven Journal-Courier. During his tenure in Waterbury, he won two �Connecticut Sportswriter of the Year� awards from the National Sportscasters and Sportswriters Association. His cover story for the Fairfield County Advocate, �The Devil Drives,� was cited in The Best American Sportswriting 1993. Away from the sports arena, Don was the founding editor of the Greenwich Citizen, a weekly newspaper that garnered several awards� including one for General Excellence�from the New England Press Association and the Connecticut Press Club. He is a contributing columnist to two news websites, Fairfield Patch and Naugatuck Patch. Don and his wife, Patti, reside in Fairfield, Connecticut.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0